// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  border: 1px solid #ada8a8; /* Border style */
  border-radius: 8px; /* Optional: Rounded corners */
  padding: 16px; /* Padding inside the container */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a subtle shadow */
}

::ng-deep .mat-horizontal-stepper-header-container {
  margin-bottom: 40px;
  margin-top: 20px;
}

.hidden-zoom {
  display: none;
}

button {
  background-color: #3f51b5;
  color: #fff;
  float: right;
  margin: 10px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/ministry/municipalities/add-municipalities/add-municipalities.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA,EAAA,iBAAA;EACA,kBAAA,EAAA,8BAAA;EACA,aAAA,EAAA,iCAAA;EACA,wCAAA,EAAA,kCAAA;AACF;;AAIA;EACE,mBAAA;EACA,gBAAA;AADF;;AAMA;EACE,aAAA;AAHF;;AAQA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AALF","sourcesContent":[".form-container {\r\n  border: 1px solid #ada8a8; /* Border style */\r\n  border-radius: 8px; /* Optional: Rounded corners */\r\n  padding: 16px; /* Padding inside the container */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a subtle shadow */\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-horizontal-stepper-header-container{\r\n  margin-bottom: 40px;\r\n  margin-top: 20px;\r\n\r\n}\r\n\r\n\r\n.hidden-zoom {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\nbutton {\r\n  background-color: #3f51b5;\r\n  color: #fff;\r\n  float:right;\r\n  margin: 10px 10px;\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
